import { createAnalytics } from '@/shared/features/analytics/config/analytics.build';
import { getConnectoId } from '@/shared/features/analytics/utils/facebookCommonAttributes';

/**
 * Fires route-level PageView to Meta (pixel + CAPI) and WebEngage.
 * Common client attributes (Page Name, UTM params, etc.) are merged by the WebEngage adapter.
 * Facebook mapping is handled by FacebookAdapter.
 */
export function trackPageView(): void {
  const connectoId = getConnectoId();
  void createAnalytics()
    .then((analytics) => {
      analytics.trackEvent(
        'PageView',
        connectoId ? { CONNECTO_ID: connectoId } : {},
        { eventProviders: ['webengage', 'facebook'] },
      );
    })
    .catch(() => {
      // Analytics may be unavailable if SDK init failed
    });
}
